import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    Button,
    componentStyles,
    TextLarge,
} from "@mallardbay/lib-react-components"
import React from "react"
import { navigate } from "gatsby-link"

import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/test-ids"
import { navigateBackOrHome } from "~utils/navigation-helpers"
import { getUrlQueryParam } from "~utils/url-param-helpers"
import { QUERY_STRING_PROPS } from "~config/constants"

export default function BackButton({
    onBackClick,
    label = COPY.BACK,
}: {
    readonly onBackClick?: () => void
    readonly label?: string
}) {
    const styles = useStyles()

    return (
        <Button
            testId={TEST_IDS.BACK_BUTTON}
            style={styles.root}
            leftIcon={<FontAwesomeIcon icon={faArrowLeft} fontSize={16} />}
            onClick={() => handleClick({ onBackClick })}
            variant="ghost"
            size="sm"
        >
            <TextLarge>{label}</TextLarge>
        </Button>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            paddingX: 2,
            marginBottom: 2,
        },
    })
}

function handleClick({ onBackClick }: { onBackClick?: () => void }) {
    const backRoute = getUrlQueryParam(QUERY_STRING_PROPS.BACK_ROUTE)

    // If an onBackClick handler was passed, use it.
    if (onBackClick) {
        onBackClick()
        return
    }

    // If there is a back route in the query string, use it.
    if (backRoute) {
        void navigate(backRoute)
        return
    }

    // Otherwise, use the default back button behavior.
    navigateBackOrHome()
}
